import React, { FC, ReactNode, useEffect, useState } from "react";
import Button from "shared/Button/Button";

import HeaderFilter from "./HeaderFilter";
import TourCard from "components/TourCard/TourCard";
import { fetchTours } from "../../data/tour/_requests";

export interface SectionGridFeaturePlacesProps {
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
}

export interface TourDataType {
  id: string | number;
  tour_title: string;
  description: string;
  number_of_days: number;
  availability: string;
  banner_image: string;
  old_base_price: number;
  base_price: number;
  slug: string;
  seo_tour_name: string;
  seo_keywords: string;
  seo_description: string;
  arrival_city: string;
}

const SectionGridFeaturePlaces: FC<SectionGridFeaturePlacesProps> = ({
  gridClass = "",
  heading = "Featured Tours",
  subHeading = "Featured tours recommended for you",
}) => {
  const [loading, setLoading] = useState(true);
  const [tours, setTours] = useState<TourDataType[]>([]);

  useEffect(() => {
    const fetchToursData = async () => {
      // setTimeout(() => {
      //   setLoading(false);
      //   setTours([
      //     {
      //       id: 26,
      //       tour_title: "2 for 1 India",
      //       description:
      //         "Delhi, Jaipur & Agra - Discover the magic of India's famous Golden Triangle & Rajasthan Witness the awe-inspiring Taj Mahal at sunrise",
      //       availability: "28 Feb - 21 Nov '24",
      //       old_base_price: 1100.0,
      //       base_price: 900.0,
      //       banner_image:
      //         "https://source.unsplash.com/featured/1920x1080/?rome",
      //       slug: "paris,-france---rome,-italy---1",
      //       seo_tour_name: "Paris, France - Rome, Italy - 1",
      //       seo_keywords: "null",
      //       seo_description: "null",
      //       number_of_days: 48,
      //     },
      //     {
      //       id: 28,
      //       tour_title:
      //         "Discover the best of Mauritius, Egypt, Jordan, Italy, Switzerland & more",
      //       description:
      //         "Search for wildlife from elephants to rhinos, lions, buffalo, leopards & more",
      //       availability: "28 Feb - 21 Nov '24",
      //       number_of_days: 48,
      //       old_base_price: 1100.0,
      //       base_price: 900.0,
      //       banner_image:
      //         "https://source.unsplash.com/featured/1920x1080/?london",
      //       slug: "new-york,-united-states---london,-united-kingdom---1",
      //       seo_tour_name:
      //         "New York, United States - London, United Kingdom - 1",
      //       seo_keywords: "null",
      //       seo_description: "null",
      //     },
      //     {
      //       id: 30,
      //       tour_title:
      //         "Discover the highlights of exotic Sri Lanka in style",
      //       description:
      //         "Stay in the award winning 5-star Heritance Kandalama Hotel",
      //       availability: "28 Feb - 21 Nov '24",
      //       number_of_days: 23,
      //       old_base_price: 1100.0,
      //       base_price: 900.0,
      //       banner_image:
      //         "https://source.unsplash.com/featured/1920x1080/?seoul",
      //       slug: "tokyo,-japan---seoul,-south-korea---1",
      //       seo_tour_name: "Tokyo, Japan - Seoul, South Korea - 1",
      //       seo_keywords: "null",
      //       seo_description: "null",
      //     },
      //     {
      //       id: 32,
      //       tour_title:
      //         " Take in the iconic views of Mt Fuji on this unbeatable",
      //       description:
      //         "Uncover the wonders of Japan with our best-value tour yet Explore Meiji Shrine, Mt Fuji’s 5th Station, Nara Park & more",
      //       availability: "28 Feb - 21 Nov '24",
      //       number_of_days: 35,
      //       old_base_price: 1100.0,
      //       base_price: 900.0,
      //       banner_image:
      //         "https://source.unsplash.com/featured/1920x1080/?shanghai",
      //       slug: "beijing,-china---shanghai,-china---1",
      //       seo_tour_name: "Beijing, China - Shanghai, China - 1",
      //       seo_keywords: "null",
      //       seo_description: "null",
      //     },
      //     {
      //       id: 35,
      //       tour_title: "Get ready for the ultimate NRL Experience!",
      //       description:
      //         "Witness history when the NRL heads to Las Vegas in 2024 NRL chartered Qantas tour to Las Vegas, your choice of accommodation & more",
      //       availability: "28 Feb - 21 Nov '24",
      //       number_of_days: 50,
      //       old_base_price: 1100.0,
      //       base_price: 900.0,
      //       banner_image:
      //         "https://source.unsplash.com/featured/1920x1080/?london",
      //       slug: "new-york,-united-states---london,-united-kingdom---1",
      //       seo_tour_name:
      //         "New York, United States - London, United Kingdom - 1",
      //       seo_keywords: "null",
      //       seo_description: "null",
      //     },
      //     {
      //       id: 36,
      //       tour_title:
      //         "Marvel at the 102-story Empire State Building in New York.",
      //       description:
      //         "Delhi, Jaipur & Agra - Discover the magic of India's famous Golden Triangle & Rajasthan Witness the awe-inspiring Taj Mahal at sunrise",
      //       availability: "28 Feb - 21 Nov '24",
      //       number_of_days: 26,
      //       old_base_price: 1100.0,
      //       base_price: 900.0,
      //       banner_image:
      //         "https://source.unsplash.com/featured/1920x1080/?paris",
      //       slug: "london,-united-kingdom---paris,-france---1",
      //       seo_tour_name: "London, United Kingdom - Paris, France - 1",
      //       seo_keywords: "null",
      //       seo_description: "null",
      //     },
      //     {
      //       id: 38,
      //       tour_title:
      //         "Marvel at picturesque terraced rice fields and beautiful mountains in Sapa",
      //       description:
      //         "Delhi, Jaipur & Agra - Discover the magic of India's famous Golden Triangle & Rajasthan Witness the awe-inspiring Taj Mahal at sunrise",
      //       availability: "28 Feb - 21 Nov '24",
      //       number_of_days: 40,
      //       old_base_price: 1100.0,
      //       base_price: 900.0,
      //       banner_image:
      //         "https://source.unsplash.com/featured/1920x1080/?auckland",
      //       slug: "sydney,-australia---auckland,-new-zealand---1",
      //       seo_tour_name: "Sydney, Australia - Auckland, New Zealand - 1",
      //       seo_keywords: "null",
      //       seo_description: "null",
      //     },
      //     {
      //       id: 39,
      //       tour_title: "Beijing, China - Shanghai, China - 1",
      //       description:
      //         "Delhi, Jaipur & Agra - Discover the magic of India's famous Golden Triangle & Rajasthan Witness the awe-inspiring Taj Mahal at sunrise",
      //       availability: "28 Feb - 21 Nov '24",
      //       number_of_days: 35,
      //       old_base_price: 1100.0,
      //       base_price: 900.0,
      //       banner_image:
      //         "https://source.unsplash.com/featured/1920x1080/?shanghai",
      //       slug: "beijing,-china---shanghai,-china---1",
      //       seo_tour_name: "Beijing, China - Shanghai, China - 1",
      //       seo_keywords: "null",
      //       seo_description: "null",
      //     },
      //   ]);
      // }, 1000); // 1 second delay

        try {
          setLoading(true);
          const response = await fetchTours({
            is_featured: 1, // Set the filter for is_featured = 1
            limit: 8, // Set the limit to 8
          });
          setTours(response.data.data);
          setLoading(false);
        } catch (error) {
          console.error("Error fetching tours:", error);
        }
    };

    fetchToursData();
  }, []);

  const renderCard = (tour: TourDataType) => {
    return <TourCard key={tour.id} data={tour} />;
  };

  return (
    <div className="nc-SectionGridFeaturePlaces relative">
      <HeaderFilter
        tabActive={""}
        subHeading={subHeading}
        tabs={[]}
        heading={heading}
        onClickTab={() => {}}
      />
      {loading ? (
        <div>Loading tours...</div>
      ) : (
        <div
          className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ${gridClass}`}
        >
          {tours.map((tour) => renderCard(tour))}
        </div>
      )}
      <div className="flex mt-16 justify-center items-center">
        <Button href="/tours" className="bg-red-700 hover:bg-red-800">
          Show me more
        </Button>
      </div>
    </div>
  );
};

export default SectionGridFeaturePlaces;
